import { DashboardAPI } from "utils/api";

export const importH2kFile = async (formData, data = {}) => {
    const { name = "", notes = "", templateID = "", templateName = "", parentFolderId = "" } = data;

    return DashboardAPI({
        method: "POST",
        url: "/createHouseModelFromFile",
        file: formData,
        headers: {
            "content-type": "multipart/form-data",
        },
    }).catch((err) => console.log(err.message));
};

export const importCodeLibFile = async (formData) => {
    return DashboardAPI({
        method: "POST",
        url: "/importCodeLibFromFile",
        file: formData,
        headers: {
            "content-type": "multipart/form-data",
        },
    }).catch((err) => console.log(err.message));
};

export const exportH2kFile = async ({
    modelId,
    returnType,
    h2kVersion,
    upgradePackage,
    appendResults,
    applyUpgradesToBase = false,
    excludeClientData = false,
    infoItemsToAdd = [],
}) => {
    return DashboardAPI({
        method: "POST",
        url: "/getHouseModel",
        data: {
            id: modelId,
            returnType: returnType ? returnType : "XML",
            h2kVersion: h2kVersion ? h2kVersion : "v11-9",
            upgradePackage: upgradePackage ? upgradePackage : "",
            appendResults: appendResults ? appendResults : false,
            applyUpgradesToBase,
            excludeClientData,
            infoItemsToAdd,
        },
    })
        .then((data) => data.data)
        .catch((err) => console.log(err.message));
};

const extractHouseFileXml = (payload = "") => {
    const body = String(payload || "");
    const splitPackage = body.split("\r");
    const startInd = splitPackage.findIndex((el) => el.includes("<HouseFile"));
    const endInd = splitPackage.findIndex((el) => el.includes("</HouseFile>"));

    if (startInd === -1 || endInd === -1) {
        return body.includes("<HouseFile") ? body : "";
    }

    let h2kData = splitPackage.slice(startInd, endInd + 1).join("\r");
    if (h2kData.charAt(0) === "\r" || h2kData.charAt(0) === "\n") {
        h2kData = h2kData.substring(1);
    }
    return h2kData;
};

export const replaceModelWithReferenceHouse = async ({ modelId, referenceHouse, confirmation }) => {
    const response = await DashboardAPI({
        method: "POST",
        url: "/replaceModelWithReferenceHouse",
        data: {
            modelId,
            referenceHouse,
            confirmation,
        },
    });

    if (response?.response) {
        const data = response.response.data;
        const message =
            (typeof data === "string" ? data : data?.error || data?.message) ||
            "Could not replace the model with a reference house.";
        throw new Error(message);
    }

    const body = response?.data;
    if (!body?.success || !body?.modelData) {
        throw new Error(body?.error || "Could not replace the model with a reference house.");
    }

    return body;
};

export const resolveReferenceHouseModel = async ({ modelId, packageId }) => {
    const response = await DashboardAPI({
        method: "POST",
        url: "/resolveReferenceHouseModel",
        data: { modelId, packageId },
    });

    if (response?.response) {
        const data = response.response.data;
        const message =
            (typeof data === "string" ? data : data?.error || data?.message) ||
            "Could not resolve the reference house.";
        throw new Error(message);
    }

    const body = response?.data;
    if (!body?.success || !body?.modelData) {
        throw new Error(body?.error || "Could not resolve the reference house.");
    }

    return body;
};

export const exportReferenceHouseH2k = async ({ modelId, packageId, h2kVersion }) => {
    const response = await DashboardAPI({
        method: "POST",
        url: "/exportReferenceHouseH2k",
        data: {
            modelId,
            packageId,
            returnType: "XML",
            h2kVersion: h2kVersion || "",
        },
    });

    if (response?.response) {
        const data = response.response.data;
        const message =
            (typeof data === "string" ? data : data?.error || data?.message) || "Could not export the reference house.";
        throw new Error(message);
    }

    const xml = extractHouseFileXml(response?.data);
    if (!xml || !xml.includes("<HouseFile")) {
        throw new Error("The reference house export did not return an .h2k file.");
    }

    return xml;
};

export const exportH2kFileWithResults = async ({ modelId, userId, packages = [], applyUpgradesToBase = false }) => {
    return DashboardAPI({
        method: "POST",
        url: "/getHouseModelWithResults",
        data: {
            modelId,
            userId,
            packages,
            applyUpgradesToBase,
        },
    })
        .then((data) => data.data)
        .catch((err) => console.log(err.message));
};

export const validateH2kExport = async ({ modelId, h2kVersion, upgradePackage, isSimulation = false }) => {
    return DashboardAPI({
        method: "POST",
        url: "/validateH2kExport",
        data: {
            id: modelId,
            h2kVersion: h2kVersion ? h2kVersion : "v11-9",
            upgradePackage: upgradePackage ? upgradePackage : "",
            isSimulation,
        },
    })
        .then((data) => data.data)
        .catch((err) => console.log(err.message));
};

export const sendDataToBKC = async ({ modelId, modelData }) => {
    return DashboardAPI({
        method: "POST",
        url: "/sendDataToBKC",
        data: {
            modelId,
            modelData,
        },
    })
        .then((data) => {
            // Return the response data which contains success/error info
            return data.data;
        })
        .catch((err) => {
            // Return error information in a format that can be checked in the component
            if (err.response && err.response.data) {
                // Server responded with error data
                return err.response.data;
            }
            // Network error or other exception
            throw err;
        });
};

export const pushCodeLibraryToBKC = async ({ codeRefs = [] }) => {
    return DashboardAPI({
        method: "POST",
        url: "/pushCodeLibraryToBKC",
        data: {
            pushEntireCodeLibrary: false,
            codeRefs,
        },
    })
        .then((data) => data.data)
        .catch((err) => {
            if (err.response && err.response.data) {
                return err.response.data;
            }
            throw err;
        });
};
